import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const VAT = 23;

export type Foil = {
  key: string;
  label: string;
  color: string;
  border: string;
  desc: string;
  hint?: string;
  gradient?: string;
};

export const FOLIE: Foil[] = [
  { key: "biala-standard", label: "Biała standardowa - mocny klej", color: "#ffffff", border: "#ccc", desc: "Klasyczna biała folia winylowa, idealna pod pełnokolorowy nadruk. Uniwersalne zastosowanie." },
  { key: "biala-ultra-mocny", label: "Biała z ultra mocnym klejem – polimerowa", color: "#ffffff", border: "#ccc", desc: "Folia polimerowa z wzmocnionym klejem do trudnych powierzchni." },
  { key: "przezroczysta", label: "Przezroczysta + możliwość poddruk kolorem białym", color: "transparent", border: "#8ab4f8", desc: "Transparentna folia z nadrukiem białym kolorem. Efekt szklanego, przeźroczystego tła." },
  { key: "ultra-przejrzysta", label: "Ultra przejrzysta + możliwość poddruk kolorem białym", color: "transparent", border: "#8ab4f8", desc: 'Najwyższa przejrzystość – niemal niewidoczna folia. Idealny efekt „bez folii" na jasnych powierzchniach.' },
  { key: "szczotkowana-stal", label: "Szczotkowana stal / aluminium + możliwość poddruk kolorem białym", color: "#b0b8c4", border: "#8a929e", desc: "Metaliczny efekt szczotkowanego aluminium. Nadaje premium wygląd – popularna w branży automotive.", gradient: "linear-gradient(135deg, #9aa3af, #d0d5db, #9aa3af)" },
  { key: "chrom-zloty", label: "Chrom złoty – lustrzana + możliwość poddruk kolorem białym", color: "#d4a017", border: "#b8860b", desc: "Lustrzana złota powierzchnia o wysokim połysku. Ekskluzywny, luksusowy efekt.", hint: "Biały nadruk wpada w delikatny odcień złota", gradient: "linear-gradient(135deg, #b8860b, #ffd700, #b8860b)" },
  { key: "chrom-srebrny", label: "Chrom srebrny – lustrzana + możliwość poddruk kolorem białym", color: "#d0d5db", border: "#a0a8b4", desc: "Lustrzana srebrna folia z efektem chromu. Wysoki połysk, elegancki wygląd.", gradient: "linear-gradient(135deg, #a0a8b4, #e8ecf0, #a0a8b4)" },
  { key: "mat-srebrny", label: "Mat srebrny + możliwość poddruk kolorem białym", color: "#a0a8b0", border: "#808890", desc: "Matowa srebrna folia bez odbić światła. Stonowany, profesjonalny charakter." },
  { key: "mat-zloty", label: "Mat złoty + możliwość poddruk kolorem białym", color: "#c4a035", border: "#a08020", desc: "Ciepły, elegancki złoty satynowy efekt.", hint: "Biały nadruk wpada w delikatny odcień złota" },
  { key: "holo-pelne", label: "Holograficzna pełne spektrum + możliwość poddruk kolorem białym", color: "#c0c0c0", border: "#888", desc: "Tęczowy efekt holograficzny zmieniający kolor pod różnym kątem. Bardzo intensywny, przyciągający uwagę.", gradient: "linear-gradient(135deg, #ff6b6b, #ffd93d, #6bcb77, #4d96ff, #9b59b6)" },
  { key: "holo-duzy-brokat", label: "Holograficzna duży brokat + możliwość poddruk kolorem białym", color: "#c0c0c0", border: "#888", desc: "Duże holograficzne drobinki brokatu – efekt migoczących iskier. Widoczny z daleka.", gradient: "linear-gradient(135deg, #e8d5f5, #ffd93d, #a8e6cf, #c4b5fd)" },
  { key: "holo-mini-brokat", label: "Holograficzna mini brokat + możliwość poddruk kolorem białym", color: "#c0c0c0", border: "#888", desc: "Drobny holograficzny brokat – subtelniejszy efekt migotania, delikatniejszy od dużego brokatu.", gradient: "linear-gradient(135deg, #ddd6fe, #fbcfe8, #bfdbfe)" },
  { key: "holo-szklo", label: "Holograficzna szkło tłuczone + możliwość poddruk kolorem białym", color: "#c0c0c0", border: "#888", desc: "Efekt potłuczonego szkła z holograficznym refleksem. Unikatowy, geometryczny wzór.", gradient: "linear-gradient(135deg, #93c5fd, #c4b5fd, #e0e7ff, #93c5fd)" },
  { key: "odblaskowa", label: "Odblaskowa – tzw. Refleksyjna + możliwość poddruk kolorem białym", color: "#e0e8f0", border: "#c0c8d0", desc: "Odbija światło w ciemności – idealna do zastosowań BHP, oznakowania i reklamy nocnej.", gradient: "linear-gradient(135deg, #f0f4f8, #ffed4a, #f0f4f8)" },
];

export const PRICE_TABLES: Record<number, { areas: number[]; prices: number[] }> = {
  1:    { areas: [0.25, 0.5, 1, 2, 4, 15, 50, 100, 150, 300, 500, 800, 1100], prices: [30.54, 37.83, 46.78, 54.89, 62.37, 62.37, 62.37, 62.37, 62.37, 62.37, 62.37, 62.37, 62.37] },
  50:   { areas: [0.25, 0.5, 1, 2, 4, 15, 50, 100, 150, 300, 500, 800, 1100], prices: [1.338, 1.681, 2.0493, 2.4045, 2.7324, 2.7324, 4.5144, 6.8112, 9.2862, 15.50, 23.00, 34.00, 45.00] },
  100:  { areas: [0.25, 0.5, 1, 2, 4, 15, 50, 100, 150, 300, 500, 800, 1100], prices: [0.771, 0.968, 1.1806, 1.3852, 1.5741, 1.8612, 3.4056, 5.5737, 7.7319, 13.00, 19.50, 29.00, 38.50] },
  200:  { areas: [0.25, 0.5, 1, 2, 4, 15, 50, 100, 150, 300, 500, 800, 1100], prices: [0.431, 0.542, 0.6608, 0.7754, 0.8811, 1.2276, 2.7819, 4.7421, 6.435, 10.80, 16.20, 24.50, 32.50] },
  300:  { areas: [0.25, 0.5, 1, 2, 4, 15, 50, 100, 150, 300, 500, 800, 1100], prices: [0.334, 0.420, 0.5123, 0.6011, 0.6831, 1.0692, 2.574, 4.2867, 6.2469, 10.00, 15.00, 22.80, 30.20] },
  500:  { areas: [0.25, 0.5, 1, 2, 4, 15, 50, 100, 150, 300, 500, 800, 1100], prices: [0.228, 0.286, 0.3490, 0.4095, 0.4653, 0.9306, 2.1681, 4.1283, 5.8806, 9.50, 14.20, 21.50, 28.50] },
};

export const QTY_LIST = [1, 50, 100, 200, 300, 500];
export const MIN_ORDER_NET = 100;
export const MAX_WIDTH_MM = 380;
export const MAX_HEIGHT_MM = 280;
export const MIN_SIDE_MM = 5;

export function lerpVal(x: number, xs: number[], ys: number[]) {
  if (x <= xs[0]) return ys[0];
  if (x >= xs[xs.length - 1]) return ys[ys.length - 1];
  for (let i = 0; i < xs.length - 1; i++) {
    if (xs[i] <= x && x <= xs[i + 1]) {
      const t = (x - xs[i]) / (xs[i + 1] - xs[i]);
      return ys[i] + t * (ys[i + 1] - ys[i]);
    }
  }
  return ys[ys.length - 1];
}

export function calcPrice(
  wMm: number,
  hMm: number,
  qty: number,
  shape: string,
  adjustPercent: number,
  foilAdjustPercent: number,
  qtyAdjustPercent: number = 0,
  baseQty: number | null = null,
) {
  if (!wMm || !hMm || wMm < MIN_SIDE_MM || hMm < MIN_SIDE_MM || qty < 1) return null;
  const areaCm2 = (wMm / 10) * (hMm / 10);
  function unitForQty(q: number) {
    const tbl = PRICE_TABLES[q];
    return lerpVal(areaCm2, tbl.areas, tbl.prices);
  }
  const priceQty = baseQty ?? qty;
  let unitNet: number;
  if (priceQty <= 1) {
    unitNet = unitForQty(1);
  } else if (priceQty < 50) {
    const base50 = unitForQty(50);
    const sqBreaks = [2, 5, 10, 15, 20, 25, 35, 49];
    const sqSurcharges = [220, 164, 76, 45, 32, 21, 17.6, 0];
    const surcharge = lerpVal(priceQty, sqBreaks, sqSurcharges);
    unitNet = base50 * (1 + surcharge / 100);
  } else {
    const qtyLower = QTY_LIST.filter((q) => q <= priceQty).pop() || QTY_LIST[0];
    const qtyUpper = QTY_LIST.find((q) => q > priceQty) || QTY_LIST[QTY_LIST.length - 1];
    if (qtyLower === qtyUpper) {
      unitNet = unitForQty(qtyLower);
    } else {
      const t = (priceQty - qtyLower) / (qtyUpper - qtyLower);
      unitNet = unitForQty(qtyLower) + t * (unitForQty(qtyUpper) - unitForQty(qtyLower));
    }
  }
  unitNet = unitNet * (1 + adjustPercent / 100) * (1 + foilAdjustPercent / 100) * (1 + qtyAdjustPercent / 100);
  unitNet = Math.round(unitNet * 100) / 100;
  let totalNet = Math.round(unitNet * qty * 100) / 100;
  if (totalNet < MIN_ORDER_NET) {
    totalNet = MIN_ORDER_NET;
    unitNet = Math.round((MIN_ORDER_NET / qty) * 100) / 100;
    totalNet = Math.round(unitNet * qty * 100) / 100;
  }
  const vatAmount = Math.round(totalNet * VAT) / 100;
  const totalGross = Math.round((totalNet + vatAmount) * 100) / 100;
  const unitNetDisplay = unitNet;
  const unitGross = Math.round(unitNetDisplay * 1.23 * 100) / 100;
  return { totalNet, unitNet: unitNetDisplay, unitGross, totalGross, vatAmount, areaCm2 };
}

export const fmtPln = (n: number) => {
  const rounded = Math.round((n + Number.EPSILON) * 100) / 100;
  return new Intl.NumberFormat("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rounded);
};

export type QtyTier = { min: number; max: number | null; adj: number };

/** Global + per-foil + per-quantity price adjustments configured in the CMS. */
export function usePricingAdjustments() {
  const [adjustPercent, setAdjustPercent] = useState(0);
  const [foilAdjustments, setFoilAdjustments] = useState<Record<string, number>>({});
  const [qtyPricingMap, setQtyPricingMap] = useState<Record<string, QtyTier[]>>({});

  useEffect(() => {
    supabase
      .from("pricing_settings")
      .select("price_adjustment_percent")
      .limit(1)
      .single()
      .then(({ data }) => {
        if (data) setAdjustPercent(Number(data.price_adjustment_percent));
      });
    supabase
      .from("foil_pricing")
      .select("id, foil_key, adjustment_percent")
      .then(({ data }) => {
        if (!data) return;
        const map: Record<string, number> = {};
        const foilIdToKey: Record<string, string> = {};
        data.forEach((f: { id: string; foil_key: string; adjustment_percent: number | string }) => {
          map[f.foil_key] = Number(f.adjustment_percent);
          foilIdToKey[f.id] = f.foil_key;
        });
        setFoilAdjustments(map);
        supabase
          .from("foil_quantity_pricing")
          .select("foil_id, quantity_min, quantity_max, adjustment_percent")
          .order("quantity_min")
          .then(({ data: qtyData }) => {
            if (!qtyData) return;
            const qMap: Record<string, QtyTier[]> = {};
            qtyData.forEach((q: { foil_id: string; quantity_min: number; quantity_max: number | null; adjustment_percent: number | string }) => {
              const key = foilIdToKey[q.foil_id];
              if (!key) return;
              if (!qMap[key]) qMap[key] = [];
              qMap[key].push({ min: q.quantity_min, max: q.quantity_max, adj: Number(q.adjustment_percent) });
            });
            setQtyPricingMap(qMap);
          });
      });
  }, []);

  /** Quantity tier for a foil: percentage adjustment + base quantity used for the unit price. */
  const getQtyTier = (foilKey: string, quantity: number): { adj: number; baseQty: number | null } => {
    if (quantity < 1) return { adj: 0, baseQty: null };
    const tiers = qtyPricingMap[foilKey];
    if (!tiers || tiers.length === 0) return { adj: 0, baseQty: null };
    const tier = tiers.find((t) => quantity >= t.min && (t.max === null || quantity <= t.max));
    return tier ? { adj: tier.adj, baseQty: tier.min } : { adj: 0, baseQty: null };
  };

  return { adjustPercent, foilAdjustments, qtyPricingMap, getQtyTier };
}
